import API from '../../API.redux';
import { endpoints } from '../../../config/endpoints';
import { joinUrlWithParams, joinUrlWithRequiredParams } from '../../../utils';

export const defaultFields = {
  index: 'id,status,application_questionnaire[id,end_date,application[id,assessment_type,company[id,name]],questionnaire[id,role,role_name,assessment[id,title,assessment_type]]]',
  // show: 'id,title,title_visible,status,total_sections,behaviour,behaviour_visible,description,description_visible,role,role_name,instructions,instructions_visible,assessment[company,assessment_type]',
  show: 'id,spent_time,pages_completion_ratio,answers,status,application_questionnaire[id,status,end_date,application[id,company[id,name], avatar_url],questionnaire[id,title,total_sections,title_visible,behaviour,behaviour_visible,description,description_visible,role,role_name,instructions,instructions_visible,introduction_cards,assessment[assessment_type]]]',
  show_public: 'hashid,pages_completion_ratio,spent_time,answers,status,application_questionnaire[id,end_date,application[id,company[id,name]],questionnaire[id,title,total_sections,title_visible,behaviour,behaviour_visible,description,description_visible,role,role_name,instructions,instructions_visible,introduction_cards,assessment[assessment_type]]]',
};

export const defaultParams = {
  index: `fields=${defaultFields.index}`,
  show: `fields=${defaultFields.show}`,
  show_public: `fields=${defaultFields.show_public}`,
};

export const getEndpoint = (which) => endpoints.respondents.enrollments[which];

export const fetchEnrollmentsIndex = (params = defaultParams.index, apiArgs = {}) => {
  const ENDPOINT = getEndpoint('index');

  return API(apiArgs)({
    url: joinUrlWithParams(ENDPOINT.url, params),
    method: ENDPOINT.method,
  });
};

export const showEnrollment = ({
  id,
  params = defaultParams.show,
  apiArgs = {},
  applicationQuestionnaireToken,
} = {}) => {
  const ENDPOINT = getEndpoint('show');

  return API(apiArgs)({
    url: joinUrlWithRequiredParams({
      params,
      url: ENDPOINT.url.replace(':id', id),
      requiredParams: ENDPOINT.requiredParams,
      ...(applicationQuestionnaireToken && {
        requiredParamsValues: { application_questionnaire_token: applicationQuestionnaireToken },
      }),
    }),
    method: ENDPOINT.method,
  });
};

export const createEnrollment = ({
  params = defaultParams.show,
  apiArgs = {},
  enrollment,
  applicationQuestionnaireToken,
}) => {
  const ENDPOINT = getEndpoint('create');

  return API(apiArgs)({
    url: joinUrlWithRequiredParams({
      params,
      url: ENDPOINT.url,
      requiredParams: ENDPOINT.requiredParams,
      ...(applicationQuestionnaireToken && {
        requiredParamsValues: { application_questionnaire_token: applicationQuestionnaireToken },
      }),
    }),
    method: ENDPOINT.method,
    data: { enrollment },
  });
};

export const finishEnrollment = ({
  id,
  params = '',
  apiArgs = {},
  applicationQuestionnaireToken,
} = {}) => {
  const ENDPOINT = getEndpoint('finish');

  return API(apiArgs)({
    url: joinUrlWithRequiredParams({
      params,
      url: ENDPOINT.url.replace(':id', id),
      requiredParams: ENDPOINT.requiredParams,
      ...(applicationQuestionnaireToken && {
        requiredParamsValues: { application_questionnaire_token: applicationQuestionnaireToken },
      }),
    }),
    method: ENDPOINT.method,
  });
};

export const updateEnrollment = ({
  params,
  apiArgs = {},
  enrollment,
  id,
  applicationQuestionnaireToken,
} = {}) => {
  const ENDPOINT = getEndpoint('update');

  return API(apiArgs)({
    url: joinUrlWithRequiredParams({
      params,
      url: ENDPOINT.url.replace(':id', id),
      requiredParams: ENDPOINT.requiredParams,
      ...applicationQuestionnaireToken && {
        requiredParamsValues: { application_questionnaire_token: applicationQuestionnaireToken },
      },
    }),
    method: ENDPOINT.method,
    data: { enrollment },
  });
};

export default {
  fetchEnrollmentsIndex,
  showEnrollment,
  createEnrollment,
  finishEnrollment,
};
